import React from 'react';
import './App.css';
import Header from "./components/Header";
import Footer from "./components/Footer";
import About from "./components/About";
import Counts from "./components/Counts";
import Services from "./components/Services";
import Features from "./components/Features";
import Testimonials from "./components/Testimonials";
import Portfolio from "./components/Portfolio";
import Faq from "./components/Faq";
import Contact from "./components/Contact";

function App() {

    return (
        <div>

            <Header/>

            <section id="hero" className="d-flex align-items-center">

                <div className="container-fluid" data-aos="fade-up">
                    <div className="row justify-content-center">
                        <div
                            className="col-xl-5 col-lg-6 pt-3 pt-lg-0 order-2 order-lg-1 d-flex flex-column justify-content-center">
                            <h1>Bettter Digital Experience With RSoft</h1>
                            <h2>We are team of talented making software</h2>
                            <div><a href="#about" className="btn-get-started scrollto">Get Started</a></div>
                        </div>
                        <div className="col-xl-4 col-lg-6 order-1 order-lg-2 hero-img" data-aos="zoom-in"
                             data-aos-delay="150">
                            <img src="assets/img/hero-img.png" className="img-fluid animated" alt=""/>
                        </div>
                    </div>
                </div>

            </section>

            <main id="main">
                <About/>
                <Counts/>
                <Services/>
                <Features/>
                <Testimonials/>
                <Portfolio/>
                <Faq/>
                <Contact/>
            </main>

            <Footer/>

            <a href="#" className="back-to-top d-flex align-items-center justify-content-center">
                <i className="bi bi-arrow-up-short"/></a>
            {/*<div id="preloader"></div>*/}

        </div>
    );
}

export default App;
